/** The person sheet's one request, by its cache key: the ⌘K palette reads the same entry for a person's name, so a deep link asks once. */
import { getMember } from "../../api/dashboard";
import { getPersonFull } from "../../api/person360";

export const personKey = (id: number): string => `v2:person:${id}:sheet`;

/** The person, the districts their CE21 address falls in (#341), and their Home, Office and state list addresses with theirs, fetched together so the sheet lands whole. A person whose member detail cannot be read simply has none. */
export function loadPerson(id: number) {
  return Promise.all([getPersonFull(id), getMember(id).catch(() => null)]).then(([person, member]) => ({
    person,
    districts: member?.legislativeDistricts ?? null,
    addresses: member?.addresses ?? { home: null, office: null, stateList: null },
  }));
}
